import React from "react";

import { useHistory } from "react-router-dom";

import { Dialog } from "primereact";
import Lottie from "react-lottie";

import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form-factory";
import ResumeFiscalNote from "../../../../components/resume";
import { Fields } from "./fields";

import { CNAESModel } from "../../../../../domain/models/cnae";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";

import { theme } from "../../../../styles/theme";
import { CardContent, Wrapper } from "./styles";

import * as animationData from "../../../../assets/animations/loading.json";

import { makeRemoteCNAES } from "../../../../../main/factories/usecases/cnaes/remote-cnaes-factory";

type PageProps = {
  loading: boolean;
  handleSubmit: (values: any, setShowConfirm: any) => Promise<void>;
  cnaesList: CNAESModel[];
  developerCompaniesList: DeveloperCompanyModel[];
  setCnaesList?: any;
  submitting?: boolean;
};

const isSmallScreen = window.innerWidth < 768;

const IssueForm: React.FC<PageProps> = ({
  loading,
  handleSubmit,
  cnaesList,
  developerCompaniesList,
  setCnaesList,
  submitting,
}) => {
  const [currentNote, setCurrentNote] = React.useState<any>();
  const [showResume, setShowResume] = React.useState<boolean>(false);
  const [showConfirm, setShowConfirm] = React.useState<boolean>(false);

  const history = useHistory();

  React.useEffect(() => {
    const loadData = async (): Promise<void> => {
      const econ = await makeRemoteCNAES().loadAll();
      setCnaesList(econ);
    };
    loadData();
  }, [currentNote, setCnaesList]);

  if (loading) return <>...</>;

  const findCompanyById = (companies: any[], id: string): any =>
    companies.find((item) => item.id === id)?.company;

  const findCnaeById = (cnaes: any[], id: string): any =>
    cnaes.find((el) => el.id === id);

  const getUpdatedNoteData = (
    values: any,
    selectedCompany: any,
    cnae: any,
  ): any => ({
    ...values,
    emissionDate: new Date().toISOString(),
    simplesNacional: selectedCompany?.simpleNacional,
    subscriptionNumber: selectedCompany?.subscriptionNumber || "",
    address: selectedCompany?.address || "",
    cnae,
  });

  const handleAddNote = async (values: any, actions: any): Promise<void> => {
    try {
      const selectedCompany = findCompanyById(
        developerCompaniesList,
        values.company,
      );
      const selectedCnae = findCnaeById(cnaesList, values.cnaes);

      const updatedNote = getUpdatedNoteData(
        values,
        selectedCompany,
        selectedCnae,
      );

      setCurrentNote((prev: any) => ({ ...prev, ...updatedNote }));
      setShowResume(true);
    } catch (error) {
      console.error("Erro ao submeter o formulário:", error);
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Wrapper>
      <BackButtom text="Emitir Nota Fiscal" />
      <CardContent>
        <FormFactory
          groups={Fields(
            cnaesList,
            developerCompaniesList,
            currentNote,
            setCurrentNote,
          )}
          enbaleCountGroup
          onSubmit={handleAddNote}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: false,
            onClick: () => history.goBack(),
            backgroundColor: theme.colors.darkBlue,
          }}
          button={{
            submit: "Gerar nota Fiscal",
            submitting: "Gerando...",
            hide: false,
            backgroundColor: theme.colors.blue400,
          }}
        />
      </CardContent>
      <Dialog
        header="Resumo da Nota Fiscal:"
        visible={showResume}
        style={{
          width: window.innerWidth < 479 ? "90vw" : "50vw",
          backgroundColor: theme.colors.darkBlue,
        }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
        }}
        footer={null}
        onHide={() => setShowResume(false)}
      >
        <ResumeFiscalNote
          submitting={submitting}
          fiscalNote={currentNote}
          onConfirmCallback={async () => {
            await handleSubmit(currentNote, setShowConfirm);
          }}
          onCancelCallback={() => setShowResume(false)}
        />
      </Dialog>
      <Dialog
        header="Aguarde!"
        visible={showConfirm}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        style={{
          width: isSmallScreen ? "90vw" : "35vw",
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        footer={null}
        onHide={() => null}
        closable={false}
      >
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={20}
          width={100}
          isStopped={false}
          isPaused={false}
        />
        <p className="text-center mt-4" style={{ maxWidth: "100%" }}>
          Nota fiscal sendo gerada. Você será redirecionado para tela de
          Listagem onde poderá fazer o download do documento quando estiver
          disponivel.
        </p>
      </Dialog>
    </Wrapper>
  );
};
export default IssueForm;
